import { Modal, ModalHeader, ModalBody } from '@kollektive/design-system';
import { ConnectionTypeCatalog } from './ConnectionTypeCatalog';
import type { ConnectionTypeDefinition } from './connectionTypeRegistry';

interface ConnectionTypeCatalogModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (type: ConnectionTypeDefinition) => void;
}

export function ConnectionTypeCatalogModal({ open, onClose, onSelect }: ConnectionTypeCatalogModalProps) {
  return (
    <Modal open={open} onClose={onClose} size="xl">
      <ModalHeader
        title="Add Connection"
        description="Choose a connection type to get started"
        onClose={onClose}
      />
      <ModalBody>
        <ConnectionTypeCatalog onSelect={onSelect} />
      </ModalBody>
    </Modal>
  );
}
